import { CdkTextareaAutosize } from '@angular/cdk/text-field';
import { HttpErrorResponse } from '@angular/common/http';
import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { MatSnackBar } from '@angular/material/snack-bar';
import {
  PedidoConsultaOutput,
  PedidoComentariosInput,
  PedidoComentariosOutput,
  PedidoIncluirComentarioInput,
  PedidoIncluirComentarioOutput
} from 'src/app/@shared/models/consulta-detalhe';
import { ConsultaDetalheService } from 'src/app/services/consulta-detalhe/consulta-detalhe.service';
import { StorageService } from 'src/app/services/storage/storage.service';

@Component({
  selector: 'app-bloco-observacao-comentario',
  templateUrl: './bloco-observacao-comentario.component.html',
  styleUrls: ['./bloco-observacao-comentario.component.scss']
})
export class BlocoObservacaoComentarioComponent implements OnInit {
  isLoading = true;
  @Input('Pedido') pedido: PedidoConsultaOutput;
  @ViewChild('autosize') autosize: CdkTextareaAutosize;
  usuario = StorageService.getPerfilUsuario();

  formComentario = new FormGroup({
    comentario: new FormControl('', Validators.compose([
      Validators.required,
      Validators.minLength(20),
      Validators.maxLength(2000)
    ]))
  })
  get comentario() { return this.formComentario.get('comentario').value; }

  public paging = { index: 0, size: 9999999, length: 0 };

  constructor(
    private consultaDetalhesService: ConsultaDetalheService,
    private snackBar: MatSnackBar,
  ) { }

  ngOnInit() {
    this.searchComentarios(this.pedido);
  }

  searchComentarios(pedido: PedidoConsultaOutput) {
    this.isLoading = true;

    const obj: PedidoComentariosInput = {
      pedidoId: pedido.pedidoId,
      paginaAtual: this.paging.index + 1,
      itensPorPagina: this.paging.size
    };

    this.consultaDetalhesService.getConsultaDadosObsComentario(obj)
      .subscribe(
        (result: PedidoComentariosOutput[]) => {
          pedido.comentarios = result;
          this.isLoading = false;
        },
        (err: HttpErrorResponse) => {
          this.isLoading = false;
          this.openSnackBar('Ocorreu um erro ao consultar os comentários do pedido, entre em contato com o suporte : ' + err.error.Protocolo ?? err.error.Message, 'OK', 10000, 'danger-snackbar');
        }
      )
  }

  incluirPedidoObsComentario() {
    const obj: PedidoIncluirComentarioInput = {
      mensagem: this.comentario,
      pedidoId: this.pedido.pedidoId,
      usuario: this.usuario.nome
    }

    this.consultaDetalhesService.incluirPedidoObsComentario(obj)
      .subscribe((response: PedidoIncluirComentarioOutput) => {
        if (response.sucesso) {
          this.searchComentarios(this.pedido);
          this.formComentario.reset();
          this.formComentario.updateValueAndValidity();
          this.openSnackBar('Comentário adicionado com sucesso!', 'OK', 3000, 'success-snackbar');
        } else {
          this.openSnackBar('Erro ao adicionar comentário. Tente mais tarde!', 'OK', 3000, 'danger-snackbar');
        }
      })
  }

  openSnackBar(message: string, action: string, duration: number, panelClass?: string): any {
    this.snackBar.open(message, action, { duration, panelClass });
  }
}
